import { useStaticQuery, graphql } from 'gatsby'

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
            alliedInfo {
              address
              siteUrl
            }
            copyrightText
            siteUrl
            submitInsurancePages {
              vehicle
              mortgage
              other
              noReferenceId
            }
            title
          }
        }
      }
    `
  )
  return site.siteMetadata
}

export { useSiteMetadata }
